import api from '../api';

export function login(username, password) {
  return api.post('/auth/login/', { username, password });
}

export function fetchMe() {
  return api.get('/auth/me/');
}

export function logout() {
  return api.post('/auth/logout/', {});
}
